var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "basic-container",
    [
      _c(
        "div",
        { staticClass: "search-area" },
        [
          _c(
            "el-form",
            {
              staticClass: "demo-form-inline",
              attrs: { inline: true, model: _vm.searchForm, size: "small" },
            },
            [
              _c(
                "el-form-item",
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "daterange",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      "value-format": "yyyy-MM-dd",
                      "picker-options": _vm.pickerOptions,
                      clearable: false,
                    },
                    model: {
                      value: _vm.submitTime,
                      callback: function ($$v) {
                        _vm.submitTime = $$v
                      },
                      expression: "submitTime",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("DynamicOption", {
                    attrs: {
                      placeholder: "全部渠道",
                      singleSelect: true,
                      params: _vm.searchOptions,
                    },
                    model: {
                      value: _vm.searchForm.appid,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "appid", $$v)
                      },
                      expression: "searchForm.appid",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "全部状态", clearable: "" },
                      model: {
                        value: _vm.searchForm.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "status", $$v)
                        },
                        expression: "searchForm.status",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "处理中", value: "0" },
                      }),
                      _c("el-option", {
                        attrs: { label: "已完成", value: "1" },
                      }),
                      _c("el-option", {
                        attrs: { label: "已关闭", value: "2" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "全部产品类型", clearable: "" },
                      model: {
                        value: _vm.searchForm.productId,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "productId", $$v)
                        },
                        expression: "searchForm.productId",
                      },
                    },
                    _vm._l(_vm.clientTypes, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-input", {
                    attrs: { placeholder: "UID", clearable: "" },
                    model: {
                      value: _vm.searchForm.uid,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "uid", $$v)
                      },
                      expression: "searchForm.uid",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleSearch },
                    },
                    [_vm._v("搜索")]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "success" },
                      on: { click: _vm.handleAdd },
                    },
                    [_vm._v("添加")]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "warning" },
                      on: { click: _vm.handleEdit },
                    },
                    [_vm._v("修改")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          attrs: {
            "cell-style": { "text-align": "center" },
            "header-cell-style": { "text-align": "center" },
            "max-height": _vm.tableHeight,
            "element-loading-text": "加载中",
            border: "",
            data: _vm.tableData,
            "row-style": { height: "30px" },
          },
        },
        [
          _c("el-table-column", {
            attrs: { type: "radio", width: "55" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-radio",
                      {
                        attrs: { label: scope.row.id },
                        on: {
                          change: function ($event) {
                            return _vm.handleRadioChange(scope.row)
                          },
                        },
                        model: {
                          value: _vm.selectedRow,
                          callback: function ($$v) {
                            _vm.selectedRow = $$v
                          },
                          expression: "selectedRow",
                        },
                      },
                      [_vm._v(" ")]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "id", label: "ID", width: "80" },
          }),
          _c("el-table-column", {
            attrs: { prop: "appid", label: "APPID", width: "120" },
          }),
          _c("el-table-column", {
            attrs: { prop: "channelName", label: "渠道名称", width: "150" },
          }),
          _c("el-table-column", {
            attrs: { prop: "productName", label: "产品类型", width: "120" },
          }),
          _c("el-table-column", {
            attrs: { prop: "uid", label: "UID", width: "240" },
          }),
          _c("el-table-column", {
            attrs: { prop: "description", label: "故障描述", width: "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: {
                          effect: "dark",
                          content: scope.row.description,
                          placement: "top",
                        },
                      },
                      [
                        _c("span", { staticClass: "ellipsis-text" }, [
                          _vm._v(_vm._s(scope.row.description)),
                        ]),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "note", label: "备注", width: "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: {
                          effect: "dark",
                          content: scope.row.note,
                          placement: "top",
                        },
                      },
                      [
                        _c("span", { staticClass: "ellipsis-text" }, [
                          _vm._v(_vm._s(scope.row.note)),
                        ]),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "status", label: "状态", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tag",
                      { attrs: { type: _vm.getStatusType(scope.row.status) } },
                      [
                        _vm._v(
                          _vm._s(_vm.getStatusText(scope.row.status)) + " "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "createTime", label: "提交时间", width: "180" },
          }),
          _c("el-table-column", {
            attrs: { prop: "createUser", label: "提交人", width: "120" },
          }),
          _c("el-table-column", {
            attrs: { label: "操作", fixed: "right", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.status === 1
                      ? _c(
                          "el-button",
                          {
                            attrs: { size: "mini", text: "", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDownload(scope.row)
                              },
                            },
                          },
                          [_vm._v("\n          下载\n        ")]
                        )
                      : _vm._e(),
                    scope.row.status === 1
                      ? _c(
                          "el-button",
                          {
                            attrs: { size: "mini", text: "", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDetail(scope.row)
                              },
                            },
                          },
                          [_vm._v("\n          详情\n        ")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table_pagination" },
        [
          _c("el-pagination", {
            staticClass: "app-pagination",
            attrs: {
              background: "",
              "current-page": _vm.pageNo,
              "page-sizes": _vm.pageSizeArr,
              "page-size": _vm.pageSize,
              layout: _vm.paginationLayout,
              total: _vm.totalCount,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c("logDetailDialog", {
        ref: "logDetailDialog",
        on: { close: _vm.closeDetailDialog },
      }),
      _c("logEditDialog", { ref: "logEditDialog", on: { saved: _vm.onSaved } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }